/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-05-16 20:54:38
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2023-04-18 18:20:41
 * @FilePath: \baishu_react_ui\src\components\dashboard\BsyDashboardCustomApp\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from "react";
import { BsyUtils } from '../../../utils/Utils';
import BsyRadioGroup from "../../BsyRadioGroup";
import BsyBubble from "../../BsyBubble";
import BsyDesignSetIconPane from "../BsyDesignSetIconPane";
import './index.css';
import tipAlert from "../../../Login/BsyAlertTip/Staticize";


export default class ExternalUrlContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customName: "",
            iconType: "system",
            appType: "url",
            openMode: "newPage",
            customUrl: "",
            imageUrl: "",
            urlBlur: false,
            isLooselyValidURL: false,
            _id: BsyUtils.Ids24(),
            style: {
                icon: 0,
                color: 3
            }
        }
    }

    componentDidMount() {
        this.getContext();
    }

    _appEditStyle = (event, data) => {
        const { imageUrl, style, iconType } = this.state
        this.oldIcon = {
            iconType: iconType,
            style: style,
            imageUrl: imageUrl,
        };
        BsyBubble({
            width: 360,
            height: 600,
            target: event,
            getContext: (e) => {
                this.bubbleContext = e;
            },
            onContentCreate: () => {
                return <BsyDesignSetIconPane
                    selectColor={style.color}
                    selectIcon={style.icon}
                    imageIcon={imageUrl}
                    // setType={iconType}
                    setChange={this.iconChange}
                    onOk={this.iconOk}
                    onCancel={this.iconCancel}
                />;
            },
            onClose: () => {
                this.setState({ style: this.oldIcon.style, iconType: this.oldIcon.iconType, imageUrl: this.oldIcon.imageUrl, })
            }
        })
    }

    oldIcon = {}

    iconChange = (e) => {
        if (e.setType === "system") {
            this.setState({
                style: {
                    icon: e.selectIcon, color: e.selectColor
                }, iconType: e.setType
            })
        } else {
            this.setState({ imageUrl: e.cropResult, iconType: e.setType })
        }
    }

    dataURLtoBlob = (t) => {
        for (var e = t.split(","), i = e[0].match(/:(.*?);/)[1], a = atob(e[1]), n = a.length, s = new Uint8Array(n); n--;)
            s[n] = a.charCodeAt(n);
        return new Blob([s], {
            type: i
        })
    }

    _createPngName = () => {
        let time = new Date().getTime() - 0;
        return "headTitle_" + time++ + ".png"
    }

    iconOk = () => {
        const { imageUrl, iconType } = this.state;
        if (iconType === "image") {
            let f = {
                file: this.dataURLtoBlob(imageUrl),
                fileName: this._createPngName()
            };

            let formData = new FormData();
            formData.append("file", f.file, f.fileName);
            formData.append("m", 'dashboard');

            React.axios('/dashboard/uploadappico', formData).then(res => {
                let da = res.data.data, str = React.language('icon.replacement.failed');
                let tx = 'warning';
                if (da.success > 0) {
                    tx = "success";
                    str = React.language('icon.replacement.successful');
                    this.setState({ imageUrl: da.avatar, iconType: iconType })
                }
                tipAlert({
                    type: tx,
                    msg: str
                });
                this.bubbleContext.onRemoveRoot();
            }).catch(res => {
                tipAlert({
                    type: 'warning',
                    msg: React.language('System.error')
                });
                this.bubbleContext.onRemoveRoot();
            })
        } else {
            this.bubbleContext.onRemoveRoot();
        }
    }

    iconCancel = () => {
        this.bubbleContext.onRemoveRoot(() => {
            this.setState({ style: this.oldIcon.style, iconType: this.oldIcon.iconType, imageUrl: this.oldIcon.imageUrl, })
        });
    }

    getContext = () => {
        this.props.getContext && this.props.getContext(this)
    }

    isLooselyValidURL = (url) => {
        const urlPattern = /^(https?:\/\/)?([\w.-]+\.[a-z]{2,6})(\/[\w.-]*)*\/?(\?[\w%&=.-]*)?(#[\w-]*)?$/i;
        return urlPattern.test(url);
    }

    render() {
        const { urlBlur, customUrl, style, iconType, openMode, customName, imageUrl, isLooselyValidURL } = this.state;

        return (
            <div className="externalUrlContent">
                <div className="url-pane">
                    <div className="url-item">
                        <div className="item-title">
                            <div className="title-text">
                                <span>{React.language("label.name")}</span>
                            </div>
                        </div>
                        <div className="item-box">
                            <input type='text' value={customName} maxLength={24} onChange={(e) => {
                                this.setState({ customName: e.target.value })
                            }} />
                        </div>
                    </div>
                    <div className="url-item">
                        <div className="item-title">
                            <div className="title-text">
                                <span>{React.language("link.address")}</span>
                            </div>
                        </div>

                        <div className={`item-box ${(!!customUrl && !isLooselyValidURL) ? "error" : ""}`}>
                            {(urlBlur && !!customUrl && !isLooselyValidURL) && <div className="item-error-tip">
                                <span>{React.language("invalid.url")}</span>
                            </div>}
                            <input onBlur={() => this.setState({ urlBlur: false })} onFocus={() => this.setState({ urlBlur: true })} type='text' value={customUrl} onChange={(e) => {
                                this.setState({ customUrl: e.target.value, isLooselyValidURL: this.isLooselyValidURL(e.target.value) })
                            }} />
                        </div>
                    </div>
                    <div className="url-item">
                        <div className="item-title">
                            <div className="title-text">
                                <span>{React.language("speedy.entry.entryItem.customIcon")}</span>
                            </div>
                        </div>
                        <div className="item-box">
                            {
                                <div className="customIconCont" onMouseEnter={(event) => {
                                    window.FX.UI.showPopover({
                                        position: "top",
                                        anchor: window.$(event.target),
                                        content: window.$("<span/>").text(React.language('change.icon')),
                                        type: "dark"
                                    })
                                }} onMouseLeave={() => {
                                    window.FX.UI.closePopover()
                                }} onClick={(e) => { this._appEditStyle(e, this.newUrlApp) }}>
                                    {
                                        (iconType === "app" || iconType === "url" || iconType === "system") && <div className={`app-icon color-cover-${style.color}`}>
                                            <div className={`imgbg-bsy-app imgbg-bsy-app-${style.icon}`}></div>
                                        </div>
                                    }
                                    {
                                        iconType === "image" && <div className={`image-icon`}>
                                            <div className={`img-bg`} style={{ backgroundImage: `url(${imageUrl})`, backgroundSize: "100%" }}></div>
                                        </div>
                                    }
                                    <div className="edit-icon">
                                        <i className="icon-bsy-reportmenu-1"></i>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="url-item">
                        <div className="item-title">
                            <div className="title-text">
                                <span>{React.language("speedy.entry.entryItem.openType")}</span>
                                <i className="icon-shixinhelp" onMouseEnter={(event) => {
                                    window.FX.UI.showPopover({
                                        position: "top",
                                        anchor: window.$(event.target),
                                        content: window.$("<span/>").text(React.language('speedy.entry.entryItem.openType.tips')),
                                    })
                                }} onMouseLeave={() => {
                                    window.FX.UI.closePopover()
                                }}></i>
                            </div>
                        </div>
                        <div className="item-box">
                            <BsyRadioGroup
                                layout={'horizontal'}
                                value={openMode || 'current'}
                                items={[{
                                    value: 'current',
                                    text: React.language("speedy.entry.entryItem.openType.current"),
                                }, {
                                    value: 'newPage',
                                    text: React.language("speedy.entry.entryItem.openType.newPage"),
                                }]}
                                onStopEdit={(e) => {

                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}